import {LoaderCircle} from 'lucide-react'
import type {ButtonHTMLAttributes, ReactNode} from 'react'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'unstyled'
export type ButtonSize = 'default' | 'compact'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  loading?: boolean
  loadingLabel?: string
}

export function Button({variant = 'secondary', size = 'default', className = '', type = 'button', loading = false, loadingLabel, children, disabled, ...props}: ButtonProps) {
  const classes = [variant === 'primary' ? 'primary-button' : variant === 'secondary' ? 'secondary-button' : variant === 'ghost' ? 'icon-button' : '', size === 'compact' ? 'compact' : '', className].filter(Boolean).join(' ')
  const content: ReactNode = loading ? <><LoaderCircle className="button-spinner" aria-hidden="true"/>{loadingLabel ?? children}</> : children
  return <button {...props} type={type} className={classes} disabled={disabled || loading} aria-busy={loading || undefined}>{content}</button>
}
